import React, { useEffect } from 'react';
import '../styles/cricket-betting.css';

const CricketBettingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="cricket-betting-page">
      <section className="cricket-betting-intro">
        <div className="cricket-betting-intro-content">
          <h1><span className="highlight">Mahadev Cricket Betting:</span> Your Gateway to Premium Cricket Action</h1>
          <p>
            Step into the world of Mahadev Cricket Betting – where real fans meet real-time action. Whether you're new to the game or a seasoned expert, we offer the ultimate platform to place your bets with confidence and excitement.
          </p>
          <div className="cricket-betting-cta-buttons">
            <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Open Your Demo Account
            </a>
            <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="cricket-betting-intro-image">
          <img src="/cricket-betting.webp" alt="Cricket Betting" className="cricket-image" />
        </div>
      </section>

      <section className="cricket-betting-features">
        <h2>Why Choose <span>Mahadev Cricket Betting</span>?</h2>
        <ol>
          <li>
            <strong>Personalized Cricket ID:</strong> Receive your own secure and fast-access Mahadev Cricket ID to start playing instantly.
          </li>
          <li>
            <strong>Lightning-Fast Onboarding:</strong> No long forms, no confusion. Our registration process is quick and efficient so you can focus on the game.
          </li>
          <li>
            <strong>All-in-One Mobile Access:</strong> Bet anytime, anywhere with our smooth and responsive mobile app designed for true cricket lovers.
          </li>
          <li>
            <strong>24/7 Support:</strong> Whether it's a simple query or detailed help, our team is available round-the-clock via WhatsApp.
          </li>
        </ol>
        <div className="cricket-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="cricket-betting-getting-started">
        <h2>How to Begin with <span>Mahadev Betting</span></h2>
        <ol>
          <li>
            <strong>Create Your ID:</strong> Connect with our support team to generate your Mahadev Cricket ID within minutes.
          </li>
          <li>
            <strong>Access Your Dashboard:</strong> Log in to your dashboard and explore our live match listings and betting options.
          </li>
          <li>
            <strong>Pick a Match:</strong> Choose your preferred match or tournament – from IPL to international fixtures.
          </li>
          <li>
            <strong>Bet & Enjoy:</strong> Place your bets securely and watch the action unfold in real-time.
          </li>
          <li>
            <strong>Get Help Anytime:</strong> Reach out to our experts for smooth, uninterrupted gameplay and assistance.
          </li>
        </ol>
        <div className="cricket-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="cricket-betting-join">
        <h2>Join <span>Mahadev</span> and Bet Smarter</h2>
        <p>
          Experience the thrill of cricket like never before. With high returns, responsive design, and professional support, Mahadev Cricket Betting is the preferred destination for cricket bettors across the nation.
        </p>
        <div className="cricket-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default CricketBettingPage;
